<template>
  <div>
    <h3>{{ sideTitle }}</h3>
    <ul>
      <li v-for="(e, i) in sublist" :key="i" v-if="(is_top_public == 0 && e.name != 'Cooperate') || is_top_public == 1"
        @click="RouteGo(e.name)" :class="$route.meta.subname == e.name ? 'is-active' : ''">
        {{ e.title }}
      </li>
      
      <!-- {{ $store.state.HCRoutes }} -->
      <!-- <li class="active_line"></li> -->
    </ul>
    <el-button size="mini" class="back_btn" icon="iconfont icon_back" @click="RouteGo('Works')">返回工作台</el-button>
  </div>
</template>
<script>
import RoutesGroup from "@/router/RoutesGroup";
export default {
  data() {
    return {
      is_top_public: 0,//是否互联共建领头羊
      sublist: [],
      allList: [],
      array: [],
      sideTitle: null,
    };
  },

  watch: {
    $route(to, from) {
      this.getTitle();
    },
  },
  methods: {
    //  扁平化数据
    getData(arr) {
      const that = this;
      // 设置匹配标识符为children
      const mark = "children";
      arr.forEach((res) => {
        // 深拷贝数据，不改变原数组
        const resCopy = JSON.parse(JSON.stringify(res));
        // 删除当前元素children，（因为我们需要提取的内容不包括children）
        delete resCopy[mark];
        // 装填数组
        that.array.push(resCopy);
        // 如果当前对象还有children就递归一发
        if (Array.isArray(res[mark]) && res[mark].length > 0) {
          that.getData(res[mark]);
        }
      });
      return that.array;
    },
    // 提取路由集合NAME
    getRouteName() {
      const that = this;
      const NameArr = [];
      const NameArr2 = this.$route.meta.content;
      const OldArr = this.getData(this.$store.state.HCRoutes.permissions);
      for (const i in OldArr) {
        NameArr[i] = OldArr[i];
      }
      NameArr.forEach((res) => {
        for (const i in NameArr2) {
          if (res.name === NameArr2[i]) {
            // geographical页面单独特殊处理顶级党委和基层支部才能显示
            if (res.name == 'geographical') {
              let top_level = JSON.parse(sessionStorage.getItem('TOPLEVEL'));
              if (top_level || this.$store.state.IsBranch) {
                that.sublist.push(res);
              }
            }
            else {
              that.sublist.push(res);
            }
          }
        }
      });
    },
    getTitle() {
      this.is_top_public = this.$getSession("is_top_public")
      const that = this;
      const subname = this.$route.meta.subname;
      // 开发阶段COPY方便快捷，之后优化代码
      for (const i in RoutesGroup.DataQueryName) {
        if (subname === RoutesGroup.DataQueryName[i]) {
          that.sideTitle = "资料查询";
          return;
        }
      }
      for (const i in RoutesGroup.OrganizeName) {
        if (subname === RoutesGroup.OrganizeName[i]) {
          that.sideTitle = "组织生活";
          return;
        }
      }
      for (const i in RoutesGroup.ProfileName) {
        if (subname === RoutesGroup.ProfileName[i]) {
          that.sideTitle = "党组织概况";
          return;
        }
      }
      for (const i in RoutesGroup.EventRecordName) {
        if (subname === RoutesGroup.EventRecordName[i]) {
          that.sideTitle = "党务公开";
          return;
        }
      }
      for (const i in RoutesGroup.LearningName) {
        if (subname === RoutesGroup.LearningName[i]) {
          that.sideTitle = "文件管理";
          return;
        }
      }
      for (const i in RoutesGroup.ThemeName) {
        if (subname === RoutesGroup.ThemeName[i]) {
          that.sideTitle = "主题教育";
          return;
        }
      }
      for (const i in RoutesGroup.CollectMoneyName) {
        if (subname === RoutesGroup.CollectMoneyName[i]) {
          that.sideTitle = "党费管理";
          return;
        }
      }
      for (const i in RoutesGroup.CaseName) {
        if (subname === RoutesGroup.CaseName[i]) {
          that.sideTitle = "他山之石";
          return;
        }
      }
      for (const i in RoutesGroup.CoursewarEventSigneName) {
        if (subname === RoutesGroup.CoursewarEventSigneName[i]) {
          that.sideTitle = "课件资源";
          return;
        }
      }
      for (const i in RoutesGroup.MeetingRecordName) {
        if (subname === RoutesGroup.MeetingRecordName[i]) {
          that.sideTitle = this.$store.state.IsBranch ? "会议管理" : "会议管理";
          return;
        }
      }
      for (const i in RoutesGroup.DiaryName) {
        if (subname === RoutesGroup.DiaryName[i]) {
          that.sideTitle = "民情日记";
          return;
        }
      }
      for (const i in RoutesGroup.PartyerGrowName) {
        if (subname === RoutesGroup.PartyerGrowName[i]) {
          that.sideTitle = "发展党员";
          return;
        }
      }
      for (const i in RoutesGroup.BranchName) {
        if (subname === RoutesGroup.BranchName[i]) {
          that.sideTitle = "党组织管理";
          return;
        }
      }
      for (const i in RoutesGroup.ManageName) {
        if (subname === RoutesGroup.ManageName[i]) {
          that.sideTitle = "系统中心";
          return;
        }
      }
      for (const i in RoutesGroup.CareName) {
        if (subname === RoutesGroup.CareName[i]) {
          that.sideTitle = "党内关爱";
          return;
        }
      }
      for (const i in RoutesGroup.DemonstrationName) {
        if (subname === RoutesGroup.DemonstrationName[i]) {
          that.sideTitle = "党员示范岗";
          return;
        }
      }
      for (const i in RoutesGroup.WorkReportName) {
        if (subname === RoutesGroup.WorkReportName[i]) {
          that.sideTitle = "述职述廉";
          return;
        }
      }
      for (const i in RoutesGroup.TaskName) {
        if (subname === RoutesGroup.TaskName[i]) {
          that.sideTitle = "督查督办";
          return;
        }
      }
      for (const i in RoutesGroup.BranchMyTaskName) {
        if (subname === RoutesGroup.BranchMyTaskName[i]) {
          that.sideTitle = "我的任务";
          return;
        }
      }
      for (const i in RoutesGroup.BranchTaskName) {
        if (subname === RoutesGroup.BranchTaskName[i]) {
          that.sideTitle = "任务交办";
          return;
        }
      }
      for (const i in RoutesGroup.HonorWallName) {
        if (subname === RoutesGroup.HonorWallName[i]) {
          that.sideTitle = "荣誉管理";
          return;
        }
      }
      for (const i in RoutesGroup.InvitationName) {
        if (subname === RoutesGroup.InvitationName[i]) {
          that.sideTitle = "组织邀请";
          return;
        }
      }
      for (const i in RoutesGroup.StatisticsName) {
        if (subname === RoutesGroup.StatisticsName[i]) {
          that.sideTitle = "数据统计";
          return;
        }
      }
      for (const i in RoutesGroup.QualityTrainingName) {
        if (subname === RoutesGroup.QualityTrainingName[i]) {
          that.sideTitle = "党员、职工素质培训";
          return;
        }
      }
      for (const i in RoutesGroup.CheerShareName) {
        if (subname === RoutesGroup.CheerShareName[i]) {
          that.sideTitle = "凝心聚力工作平台";
          return;
        }
      }
      for (const i in RoutesGroup.DecisionManagementName) {
        if (subname === RoutesGroup.DecisionManagementName[i]) {
          that.sideTitle = "三重一大决策管理";
          return;
        }
      }
      for (const i in RoutesGroup.LargeScreenSetting) {
        if (subname === RoutesGroup.LargeScreenSetting[i]) {
          that.sideTitle = "数据可视化设置";
          return;
        }
      }
    },
  },
  mounted() {


    // 提取所有二级路由name
    this.getRouteName()
    this.getTitle()
    // v-if="top_level || $store.state.IsBranch"

    // for(const i in OrganizeName)
    // if(subname===ProfileName)
    //     console.log(this.$route.meta.subname)
    // this.sublist = this.getData(this.$store.state.HCRoutes.permissions)
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Sidebar/index.vue